import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Select} from "../../DataEntry";

const { Option } = Select;

/**
 * Options
 * - shortMode (bool): Whether to hide the currency name.
 **/
class PublicCurrencySelect extends Component {
    static defaultProps = {
        ignoreSubscription: false,
    };

    renderOptions = () => {
        const {
            currencies,
        } = this.props;
        return currencies?.map(option => this.renderOption(option));
    };

    renderOption = item => (
        <Option value={item.code} key={item.code} label={`${item.code} - ${item.name}`}>
            {item.code}
            &nbsp;
            -
            &nbsp;
            {item.name}
        </Option>
    );

    render() {
        const {
            // Redux
            currencies,
            // Parent
            selectRef,
            hideMyCurrencies,
            ignoreSubscription,
            i18n,
            ...restProps
        } = this.props;

        return (
            <Select
                placeholder={t`Select Currency`}
                dropdownMatchSelectWidth={false}
                allowClear={false}
                showSearch
                filterOption
                optionFilterProp="label"
                ref={selectRef}
                {...restProps}
            >
                {this.renderOptions()}
            </Select>
        );
    }
}

export default connect(state => ({
    currencies: state.PublicList.currencies,
}), {
    //
})(withI18n()(PublicCurrencySelect));
